module.exports = "<!-- Loaders -->\r\n<app-angular-loader></app-angular-loader>\r\n\r\n<!-- Routing -->\r\n<router-outlet></router-outlet>"